var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMarkerCluster = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_12347",
    "data-name": "Gruppe 12347",
    transform: "translate(-937 -1254)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7634",
    "data-name": "Pfad 7634",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    transform: "translate(937 1254)",
    fill: "#2b2b2b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(941 1258)",
    fill: "#2b2b2b",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(945 1262)",
    fill: "#2b2b2b"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMarkerCluster);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/marker-cluster.a03d0fc94afbd0e4f6710e3665be8684.svg";